import { ecss, cx } from '../reexports/emotion';
import { css as scss } from '@styled-system/css';
import { createHook } from 'reakit-system';
import { BoxHTMLProps } from 'reakit';
import { useTheme } from './useTheme';
import { focus } from '../utils/focusable';

export let useFocusable = createHook<any, BoxHTMLProps>({
  compose: [useTheme],
  useProps(options, props) {
    return {
      ...props,
      className: cx(props.className, ecss(scss({ '&:focus': focus })(options))),
    };
  },
});
